import { 
    generalEnquirySchema, 
    accessibilitySchema, 
    eventsSchema, 
    lostPropertySchema, 
    recentVisitSchema, 
    ticketAssistanceSchema, 
    venueHireSchema,
    employmentSchema 
  } from './schemas.js';
  // Map form configurations to their respective schemas and error mappings
  export const formConfigs = {
    General: {
      endpoint: 'general',
      schema: generalEnquirySchema,
      errorMapping: {
        submissionType: 'error-submission-type',
        firstName: 'error-ge-first-name',
        lastName: 'error-ge-last-name',
        email: 'error-ge-email',
        phone: 'error-ge-phone',
        venue: 'error-ge-venue',
        showName: 'error-ge-show-name',
        enquiry: 'error-ge-enquiry'
      }
    },
    Accessibility: {
      endpoint: 'accessibility',
      schema: accessibilitySchema,
      errorMapping: {
        submissionType: 'error-submission-type',
        firstName: 'error-ac-first-name',
        lastName: 'error-ac-last-name',
        email: 'error-ac-email',
        phone: 'error-ac-phone',
        venue: 'error-ac-venue',
        showName: 'error-ac-show-name',
        showDate: 'error-ac-show-date',
        companion: 'error-ac-companion',
        enquiry: 'error-ac-enquiry'
      }
    },
    Employment: {
      endpoint: 'employment',
      schema: employmentSchema,
      errorMapping: {
        submissionType: 'error-submission-type',
        firstName: 'error-first-name',
        lastName: 'error-last-name',
        email: 'error-email',
        phone: 'error-phone',
        workedBefore: 'error-worked-before',
        appliedBefore: 'error-applied-before',
        department: 'error-department',
        employmentType: 'error-employment-type',
        jobHeard: 'error-job-heard',
        whyWork: 'error-why-work',
        hobbies: 'error-hobbies',
        terms: 'error-terms'
      }
    },
    Events: {
      endpoint: 'events',
      schema: eventsSchema,
      errorMapping: {
        submissionType: 'error-submission-type',
        firstName: 'error-ev-first-name',
        lastName: 'error-ev-last-name',
        email: 'error-ev-email',
        phone: 'error-ev-phone',
        company: 'error-ev-company',
        venue: 'error-ev-venue',
        showName: 'error-ev-show-name',
        showDate: 'error-ev-show-date',
        showTime: 'error-ev-show-time',
        guests: 'error-ev-guests',
        alreadyPurchased: 'error-ev-already-purchased',
        foodBeverage: 'error-ev-food-beverage',
        additionalInfo: 'error-ev-additional-info'
      }
    },
    LostProperty: {
      endpoint: 'lost-property',
      schema: lostPropertySchema,
      errorMapping: {
        submissionType: 'error-submission-type',
        firstName: 'error-lp-first-name',
        lastName: 'error-lp-last-name',
        email: 'error-lp-email',
        phone: 'error-lp-phone',
        venue: 'error-lp-venue',
        showName: 'error-lp-show-name',
        showDate: 'error-lp-show-date',
        showTime: 'error-lp-show-time',
        seatingAllocation: 'error-lp-seating-allocation',
        itemDescription: 'error-lp-item-description'
      }
    },
    RecentVisit: {
      endpoint: 'recent-visit',
      schema: recentVisitSchema,
      errorMapping: {
        submissionType: 'error-submission-type',
        firstName: 'error-rv-first-name',
        lastName: 'error-rv-last-name',
        email: 'error-rv-email',
        phone: 'error-rv-phone',
        venue: 'error-rv-venue',
        showDate: 'error-rv-show-date',
        showTime: 'error-rv-show-time',
        seatingAllocation: 'error-rv-seating-allocation',
        note: 'error-rv-note'
      }
    },
    TicketPurchase: {
      endpoint: 'ticket-purchase',
      schema: ticketAssistanceSchema,
      errorMapping: {
        submissionType: 'error-submission-type',
        firstName: 'error-ta-first-name',
        lastName: 'error-ta-last-name',
        email: 'error-ta-email',
        phone: 'error-ta-phone',
        venue: 'error-ta-venue',
        showName: 'error-ta-show-name',
        showDate: 'error-ta-show-date',
        showTime: 'error-ta-show-time',
        tickets: 'error-ta-tickets',
        seating: 'error-ta-seating'
      }
    },
    VenueHire: {
      endpoint: 'venue-hire',
      schema: venueHireSchema,
      errorMapping: {
        submissionType: 'error-submission-type',
        firstName: 'error-vh-first-name',
        lastName: 'error-vh-last-name',
        email: 'error-vh-email',
        phone: 'error-vh-phone',
        company: 'error-vh-company',
        venue: 'error-vh-venue',
        showDate: 'error-vh-show-date',
        showTime: 'error-vh-show-time',
        additionalInfo: 'error-vh-additional-info'
      }
    }
  };